import React from 'react';
import { useFormContext } from 'react-hook-form';
import ReactHtmlParser from 'react-html-parser';

import { useSelector } from 'react-redux';
import useStyles from './styles';
import { convertEditorStateToHTML, parseJsonToEditorState, parseReadOnly } from '../../services/editorJS/utils';
import { selectProject } from '../../store/modules/projects/selectors';

type Props = {
  name: string;
};

const ScriptReadOnly = ({ name }:Props) => {
  const classes = useStyles();
  const { getValues } = useFormContext();
  const currentProject = useSelector(selectProject);

  const html = convertEditorStateToHTML(
    parseReadOnly(
      parseJsonToEditorState(getValues()[name]),
    ),
    {
      project: currentProject.data,
    },
  );

  return (
    <div className={classes.scriptPreview} data-intercom-target="Script preview">
      {ReactHtmlParser(html)}
    </div>
  );
};

export default ScriptReadOnly;
